<!--下载附件-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>下载附件</p>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <!-- <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请上传文件"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->
        <MyEditor
          v-model="caseProblem"
          placeholder="请上传文件"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
      <div class="upload-file">
        <div class="file-item" v-for="(file, index) in fileList" :key="index">
          <div class="filename">
            <img
              class="icon"
              src="https://ossfastmake.mustke.com/qrCode/tupian/1762401082820.svg"
            />
            <span>{{ file.fileName || `文件${index + 1}` }}</span>
          </div>
          <img
            class="del"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1761120250640.svg"
            @click="deleteFile(index)"
          />
        </div>

        <div class="button" @click="chooseFile">
          <img
            class="icon"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1761100444730.svg"
          />
          选择文件
        </div>
        <div class="text">支持word、excel、ppt、pdf格式上传</div>
      </div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
    <input
      ref="uploadInput"
      type="file"
      multiple
      accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf"
      style="display: none"
      @change="handleFileSelect"
    />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [], // 选项列表
      dataObj: {}, // 存储当前问题的数据
      showpopup: false, // 批量添加选项的弹框
      uploadIndex: 0,
      images: [], // 题目图片列表
      caseProblem: "", // 题目说明
      fileList: [],
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.caseProblemImg = JSON.stringify(this.images);

      const listData = this.fileList.map((f) => ({
        id: "",
        text: f.url,
        fileName: f.fileName || "",
      }));
      this.dataObj.chooseList = JSON.stringify({
        list: listData,
      });

      this.dataObj.caseProblem = this.caseProblem || "请输入题目说明";
      this.dataObj.pictureNum = this.pictureNum;

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    saveClick() {
      if (this.caseProblem.trim() === "") {
        this.$message.warning("请输入题目说明");
        return;
      }

      this.dataObj.caseProblemImg = JSON.stringify(this.images);

      const listData = this.fileList.map((f) => ({
        id: "",
        text: f.url,
        fileName: f.fileName || "",
      }));
      this.dataObj.chooseList = JSON.stringify({
        list: listData,
      });

      this.dataObj.caseProblem = this.caseProblem || "请输入题目说明";
      this.dataObj.pictureNum = this.pictureNum;

      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleClick() {},
    chooseFile() {
      if (this.fileList.length >= 2) {
        this.$message.warning("最多只能上传2个文件");
        return;
      }
      this.$refs.uploadInput.click();
    },

    handleFileSelect(e) {
      let files = Array.from(e.target.files);
      if (!files.length) return;

      const remaining = 2 - this.fileList.length;
      if (files.length > remaining) {
        files = files.slice(0, remaining);
        this.$message.warning("最多只能上传2个文件，已自动截取前两个");
      }

      const overLimit = files.some((f) => f.size > 30 * 1024 * 1024);
      if (overLimit) {
        this.$message.warning("文件大小不能超过30MB");
        return;
      }

      files.forEach((file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uuid", this.uuid);
        formData.append("type", "question");

        axios
          .post(baseURL + "/PCwj/file/uploads", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              token: localStorage.getItem("token"),
            },
          })
          .then((res) => {
            if (res.data.code === 200 && res.data.urls) {
              this.fileList.push({
                id: "",
                fileName: file.name,
                url: res.data.urls,
                size: file.size,
              });
              this.handleUpdateQuestion();
            } else {
              this.$message.error(res.data.msg || "上传失败");
            }
          })
          .catch(() => {
            this.$message.error("上传失败");
          });
      });

      e.target.value = "";
    },

    deleteFile(index) {
      this.$confirm("文件删除后不可恢复，确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.fileList.splice(index, 1);
          this.handleUpdateQuestion();
        })
        .catch(() => {});
    },
  },
  watch: {
    params: {
      handler(newVal) {
        if (!newVal) return;

        const data = newVal.data || newVal;
        this.dataObj = data;

        this.caseProblem = data.caseProblem || "";
        this.pictureNum = data.pictureNum || 1;

        try {
          this.images = JSON.parse(data.caseProblemImg || "[]");
        } catch (e) {
          this.images = [];
        }

        try {
          if (data.chooseList) {
            const chooseListObj = JSON.parse(data.chooseList);
            this.fileList = (chooseListObj.list || []).map((item) => ({
              fileName: item.fileName,
              url: item.text,
              id: item.id,
            }));
          } else {
            this.fileList = [];
          }
        } catch (e) {
          this.fileList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.upload-file {
  margin: 10px 0;
}

.upload-file .button {
  background: #3a60ff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 14px;
  color: #fff;
  font-weight: Semibold;
  margin-top: 10px;
  height: 39px;
  cursor: pointer;
}

.upload-file .button .icon {
  width: 17px;
  height: 17px;
}

.upload-file .text {
  font-size: 12px;
  color: #2b2f36;
  margin: 10px 0;
  text-align: center;
}

.upload-file .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file .file-item .filename {
  max-width: 90%;
  display: flex;
  align-items: center;
  gap: 8.5px;
}

.upload-file .file-item .filename .icon {
  width: 24px;
  height: 21px;
  flex: none;
}
.upload-file .file-item .filename span {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #333;
}
.upload-file .file-item .del {
  width: 16px;
  height: 16px;
}

.upload-file .file-item + .file-item {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditDownloadFile.vue